import { SelectionsState } from '../states/selections.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  purgeCommonSelections,
  purgeSelectionCommonMatchDays,
  purgeSelections,
  setSelectionCommonCompetition,
  setSelectionCommonLastDayWithMatches,
  setSelectionCommonMatchDays,
  setSelectionCommonSeason,
  setSelectionCompetition,
  setSelectionPlayers,
  setSelectionPlayersLoader,
  setSelectionPosition,
  setSelectionSeason,
  setSelectionTeams,
  setSelectionTeamsLoader
} from '../actions/selections.actions'

const initialState: SelectionsState = {
  season: undefined,
  competition: undefined,
  teams: undefined,
  teamsLoading: undefined,
  players: undefined,
  playersLoading: undefined,
  demarcation: undefined,

  commonSeason: undefined,
  commonCompetition: undefined,
  commonMatchDays: undefined,
  commonLastMatchDayIdWithMatches: undefined
}

const reducer = createReducer(
  initialState,
  on(setSelectionSeason, (state: SelectionsState, { season }) => ({ ...state, season })),
  on(setSelectionCompetition, (state: SelectionsState, { competition }) => ({ ...state, competition })),
  on(setSelectionTeams, (state: SelectionsState, { teams }) => ({ ...state, teams })),
  on(setSelectionTeamsLoader, (state: SelectionsState, { teamsLoading }) => ({ ...state, teamsLoading })),
  on(setSelectionPlayers, (state: SelectionsState, { players }) => ({ ...state, players })),
  on(setSelectionPlayersLoader, (state: SelectionsState, { playersLoading }) => ({ ...state, playersLoading })),
  on(setSelectionPosition, (state: SelectionsState, { demarcation }) => ({ ...state, demarcation })),
  on(purgeSelections, (state: SelectionsState) => ({
    ...state,
    teams: undefined,
    teamsLoading: undefined,
    players: undefined,
    playersLoading: undefined,
    position: undefined
  })),

  on(setSelectionCommonSeason, (state: SelectionsState, { commonSeason }) => ({ ...state, commonSeason })),
  on(setSelectionCommonCompetition, (state: SelectionsState, { commonCompetition }) => ({
    ...state,
    commonCompetition
  })),
  on(setSelectionCommonMatchDays, (state: SelectionsState, { commonMatchDays }) => ({ ...state, commonMatchDays })),
  on(setSelectionCommonLastDayWithMatches, (state: SelectionsState, { commonLastMatchDayIdWithMatches }) => ({
    ...state,
    commonLastMatchDayIdWithMatches
  })),
  on(purgeSelectionCommonMatchDays, (state: SelectionsState) => ({
    ...state,
    commonMatchDays: undefined,
    commonLastMatchDayIdWithMatches: undefined
  })),
  on(purgeCommonSelections, (state: SelectionsState) => ({
    ...state,
    commonSeason: undefined,
    commonCompetition: undefined,
    commonMatchDays: undefined,
    commonLastMatchDayIdWithMatches: undefined
  }))
)

export const selectionReducer = (state: SelectionsState | undefined, action: Action) => reducer(state, action)
